var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#334443",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M7.901 25h9.6c4.824 0 5.688-1.932 5.94-4.284l.9-9.6c.324-2.928-.516-5.316-5.64-5.316h-12c-5.124 0-5.964 2.388-5.64 5.316l.9 9.6C2.213 23.068 3.077 25 7.901 25Zm.001-19.2v-.96c0-2.124 0-3.84 3.84-3.84h1.92c3.84 0 3.84 1.716 3.84 3.84v.96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#334443",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M15.1 14.2v1.224c0 1.308-.011 2.376-2.4 2.376-2.375 0-2.4-1.056-2.4-2.364V14.2c0-1.2 0-1.2 1.2-1.2h2.4c1.2 0 1.2 0 1.2 1.2Zm9.182-2.4a19.781 19.781 0 0 1-9.18 3.624"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#334443",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M1.445 12.124a19.54 19.54 0 0 0 8.856 3.312"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductorIcon);
export default __webpack_public_path__ + "static/media/productorIcon.f1056daa5a6fd6df7a4a61c5ea4c3402.svg";
export { ForwardRef as ReactComponent };